import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const FieldChipSeparatorIcon: React.FC<AddIconProps> = ({ size = 18, color = '#0556CB', className, onClick }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
    <path d="M31.5669 5.8335H8.43359C7.75026 5.8335 7.18359 5.26683 7.18359 4.5835C7.18359 3.90016 7.75026 3.3335 8.43359 3.3335H31.5669C32.2503 3.3335 32.8169 3.90016 32.8169 4.5835C32.8169 5.26683 32.2503 5.8335 31.5669 5.8335Z" fill={color} />
    <path d="M31.5669 36.6665H8.43359C7.75026 36.6665 7.18359 36.0998 7.18359 35.4165C7.18359 34.7332 7.75026 34.1665 8.43359 34.1665H31.5669C32.2503 34.1665 32.8169 34.7332 32.8169 35.4165C32.8169 36.0998 32.2503 36.6665 31.5669 36.6665Z" fill={color} />
    <path d="M4.58301 13.3335V26.6668C4.58301 29.4335 6.81634 31.6668 9.58301 31.6668H30.4163C33.183 31.6668 35.4163 29.4335 35.4163 26.6668V13.3335C35.4163 10.5668 33.183 8.3335 30.4163 8.3335H9.58301C6.81634 8.3335 4.58301 10.5668 4.58301 13.3335Z" fill={color} />
  </svg>
);

export default FieldChipSeparatorIcon;